import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { Button, Container } from '@material-ui/core';
import styles from './styles';

const SITE_LINK = process.env.REACT_APP_SHARE_ICON_LINK;

const AboutUs = ( props ) => {
  const { classes } = props;

  return (
    <div className={classes.aboutUsContainer}>
      <Container maxWidth="lg">
        <Grid container spacing={0}>
          <Grid item xs={12} md={5} lg={4}>
            <div className={classes.aboutUsLeftBox}>
              <h3 className={classes.aboutUsHeading}>About us</h3>
              <p className={classes.aboutUsText}>
                We are a mission-driven non-profit organization dedicated to using evidence to transform people’s lives. We collaborate with governments, foundations, NGOs, development and research organizations across the globe.
              </p>
              <Button
                variant="outlined"
                className={classes.exploreButton}
                href={`${SITE_LINK}about`}
              >
                Explore About us
                <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }} />
              </Button>
            </div>
          </Grid>
          <Grid item xs={12} md={7} lg={8}>
            <div className={classes.aboutUsRightBox}>
              <ul className={classes.aboutUsListGrid}>
                <li><a href={`${SITE_LINK}about/meet-the-team`} rel="noopener noreferrer">Team</a></li>
                <li><a href={`${SITE_LINK}about/3ie-supporters`} rel="noopener noreferrer">Supporters</a></li>
                <li><a href={`${SITE_LINK}about/3ie-members`} rel="noopener noreferrer">Members</a></li>
                <li><a href={`${SITE_LINK}about/3ie-at-a-glance`} rel="noopener noreferrer">At a glance</a></li>
                <li><a href={`${SITE_LINK}about/governance`} rel="noopener noreferrer">Governance</a></li>
                <li><a href={`${SITE_LINK}about/3ie-partners`} rel="noopener noreferrer">Partners</a></li>
                <li><a href={`${SITE_LINK}about/policies-reports`} rel="noopener noreferrer">Institutional policies and reports</a></li>
                <li><a href={`${SITE_LINK}about/contact-us`} rel="noopener noreferrer">Contact us</a></li>
              </ul>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

AboutUs.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles( styles )( AboutUs );
